import { ICache } from './interfaces';
import { MemoryCache } from './implementations/MemoryCache';

/**
 * A class for caching values/promises.
 */
export class Cache {
  /**
   * The cache implementation to use.
   * 
   * @private
   */
  private static _innerCache: ICache = new MemoryCache();

  /**
   * Gets the value from the cache if exists, otherwise from the provided getter method and puts
   * that value in the cache.
   * 
   * @param key     The cache key to use.
   * @param getter  The value getter if cache miss.
   * @returns       The value from cache, or from the getter.
   */
  static getOrSet<T>(key: string, getter: () => T) {
    return this._innerCache.getOrSet(key, getter);
  }

  /**
   * Gets a promise from the cache if exists, otherwise puts the promise itself in the cache
   * to be shared between callers.
   * 
   * @param key     The cache key to use.
   * @param getter  The promise getter if cache miss.
   * @returns       The promise from cache, or from the getter.
   */
  static getOrSetAsync<T>(key: string, getter: () => Promise<T>) {
    return this._innerCache.getOrSetAsync(key, getter);
  }
}